// api.js
// import axios from 'axios';
const isProduction = process.env.NODE_ENV === "production";
// 创建axios实例
const instance = axios.create({
  // 统一走相对路径（同源域名与端口）；开发环境通过 devServer 代理到后端
  baseURL: isProduction
    ? `${window.location.protocol}//${window.location.host}`
    : "http://172.16.20.2:8091",
  timeout: 10000,
});
export default {
  // 获取RSA公钥
  getPublicKey() {
    return new Promise((resolve, reject) => {
      instance
        .get("/reservation/getPublicKey")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 登录请求
  login(credentials) {
    return new Promise((resolve, reject) => {
      instance
        .post("/api/login", credentials)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 获取预约人数
  getReservationNum() {
    return new Promise((resolve, reject) => {
      instance
        .get("/reservation/getReservationNum")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 预约页问答请求
  getAnswerInfo(identifyingId, questionNum, lang) {
    return new Promise((resolve, reject) => {
      instance
        .get(
          `/reservation/getAnswerInfo?identifyingId=${identifyingId}&questionNum=${questionNum}&lang=${lang}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 预约页结果保存
  saveResult(email, identifyingId, resultNumber, channel) {
    return new Promise((resolve, reject) => {
      instance
        .post("/reservation/saveResult", {
          email,
          identifyingId,
          resultNumber,
          channel,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 获取下载地址
  getDownUrl(identifyingId) {
    return new Promise((resolve, reject) => {
      instance
        .get(`/reservation/getInfo?identifyingId=${identifyingId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 获取结局记录
  getEndId(email, identifyingId, channel) {
    return new Promise((resolve, reject) => {
      instance
        .get(
          `/reservation/showEmailResult?email=${email}&identifyingId=${identifyingId}&channel=${channel}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 提交打点事件
  postSubmitEvent(eventName, fbp, eventId, fbc, externalId, eventSourceUrl) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/submitEvent`, {
          eventName,
          fbp,
          eventId,
          fbc,
          externalId,
          eventSourceUrl,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // tiktok提交打点事件
  postEventTrack(event, eventId, ttclid, email, externalId, ttp, url) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/eventTrack`, {
          event,
          eventId,
          ttclid,
          email,
          externalId,
          ttp,
          url,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 用户行为埋点提交
  postCustomEvent(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/customEvent`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 返回奖品
  getWheelPrize(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/getWheelPrize`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 分享统计
  shareClickCount(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/shareClickCount`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 预注册人数
  registerCount(pkgId) {
    return new Promise((resolve, reject) => {
      instance
        .get(`/reservation/registerCount?pkgId=${pkgId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 保存用户分享记录
  saveShareStatistics(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/saveShareStatistics`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 预注册
  saveRegisterResult(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/saveRegisterResult`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 发送验证码
  sendCode(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/send_code`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 重置密码
  sdkUserPasswdReset(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/sdkUserPasswdReset`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 注册并登录
  reservationRegisterAndLogin(params) {
    return new Promise((resolve, reject) => {
      instance
        .post(`/reservation/reservationRegisterAndLogin`, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js